import Vue from "vue";
import Vuex from "vuex";
import user from "./user.js";
import contact from "./contact.js";
import company from "./company.js";
import translation    from './translation'


Vue.use(Vuex);

let store = new Vuex.Store({
  modules: {
    user,
    company,
    contact,
    translation
  }
})
export default store